import classNames from 'classnames';
import * as React from 'react';

import { IconProps } from 'bones/design-system/components/icons/Icon';

export const LoadingIcon: React.VFC<IconProps> = ({
  className,
  size,
  ...props
}) => {
  if (size === 40) {
    return (
      <svg
        className={classNames(className, 'vb-loading')}
        fill="none"
        height="40"
        viewBox="0 0 40 40"
        width="40"
        xmlns="http://www.w3.org/2000/svg"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <g id="Size=lg">
          <path
            d="M38.5 20C39.3284 20 40.0059 20.6725 39.9438 21.4986C39.706 24.6626 38.7181 27.7324 37.0528 30.45C35.1256 33.5949 32.3662 36.1456 29.0798 37.8201C25.7934 39.4947 22.1079 40.2277 18.4308 39.9383C14.7537 39.649 11.2283 38.3484 8.2443 36.1803C5.26028 34.0123 2.93392 31.0613 1.52241 27.6537C0.110902 24.246 -0.330767 20.5143 0.246233 16.8713C0.823233 13.2283 2.39643 9.81576 4.79188 7.01104C6.86182 4.58745 9.47607 2.69927 12.4117 1.49545C13.1782 1.18113 14.0272 1.61757 14.2832 2.40546C14.5392 3.19334 14.1046 4.03344 13.3424 4.35787C10.9314 5.38402 8.78361 6.95663 7.0731 8.95938C5.03696 11.3434 3.69975 14.244 3.2093 17.3406C2.71885 20.4372 3.09427 23.6091 4.29405 26.5056C5.49383 29.4021 7.47124 31.9105 10.0077 33.7533C12.5441 35.5961 15.5407 36.7016 18.6662 36.9476C21.7917 37.1936 24.9244 36.5705 27.7178 35.1471C30.5113 33.7238 32.8568 31.5557 34.4949 28.8825C35.871 26.6368 36.703 24.1082 36.9339 21.4981C37.0069 20.6729 37.6716 20 38.5 20Z"
            fill="#F0F1F4"
            id="Ellipse 112"
          />
          <path
            d="M38.4525 18.6758C39.2789 18.6166 39.9064 17.8973 39.7854 17.0777C39.4346 14.7028 38.6584 12.4061 37.49 10.2996C36.0787 7.75494 34.1292 5.54891 31.7774 3.83542C29.4256 2.12192 26.7282 0.942241 23.8735 0.378685C21.5102 -0.087856 19.0862 -0.12284 16.7181 0.271115C15.9009 0.407058 15.4085 1.22485 15.6053 2.02956C15.8021 2.83428 16.6136 3.32011 17.4325 3.195C19.3747 2.89827 21.3575 2.9399 23.2925 3.32188C25.719 3.8009 28.0117 4.80364 30.0108 6.2601C32.0098 7.71657 33.6669 9.59169 34.8665 11.7546C35.8231 13.4794 36.4704 15.354 36.7832 17.2937C36.9151 18.1116 37.6262 18.7351 38.4525 18.6758Z"
            fill="#007FA4"
            id="Ellipse 113"
          />
        </g>
      </svg>
    );
  }

  if (size === 24) {
    return (
      <svg
        className={classNames(className, 'vb-loading')}
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        <g id="Size=md">
          <path
            d="M22.8 12C23.4627 12 24.0062 12.5386 23.9401 13.198C23.7602 14.9906 23.1784 16.7251 22.2317 18.27C21.0754 20.1569 19.4197 21.6874 17.4479 22.6921C15.476 23.6968 13.2647 24.1366 11.0585 23.963C8.85225 23.7894 6.73699 23.009 4.94658 21.7082C3.15617 20.4074 1.76035 18.6368 0.913446 16.5922C0.0665413 14.5476 -0.19846 12.3086 0.14774 10.1228C0.49394 7.93697 1.43786 5.88945 2.87513 4.20662C4.05182 2.8289 5.52166 1.73954 7.17093 1.01455C7.77764 0.747845 8.45782 1.09829 8.66261 1.72859C8.86741 2.35889 8.51811 3.02917 7.91826 3.31096C6.68745 3.88914 5.58918 4.72433 4.7001 5.7653C3.55028 7.11156 2.79515 8.74957 2.51819 10.4982C2.24123 12.2469 2.45323 14.0381 3.13076 15.6738C3.80828 17.3094 4.92493 18.7259 6.35726 19.7666C7.78959 20.8072 9.4818 21.4315 11.2468 21.5704C13.0118 21.7093 14.7808 21.3574 16.3583 20.5537C17.9358 19.7499 19.2603 18.5255 20.1853 17.016C20.9006 15.8487 21.3556 14.5461 21.5251 13.1969C21.6077 12.5393 22.1373 12 22.8 12Z"
            fill="#F0F1F4"
            id="Ellipse 112"
          />
          <path
            d="M22.7723 11.227C23.4333 11.1795 23.9369 10.6034 23.8237 9.95044C23.5949 8.63081 23.1464 7.3559 22.494 6.17974C21.6472 4.65296 20.4775 3.32934 19.0664 2.30125C17.6553 1.27315 16.0369 0.565345 14.3241 0.227211C13.0046 -0.0332722 11.6536 -0.0695392 10.3273 0.117144C9.67108 0.209521 9.27701 0.865379 9.43444 1.50915C9.59188 2.15292 10.2416 2.53918 10.8999 2.46324C11.8842 2.3497 12.8825 2.38895 13.8593 2.58177C15.2295 2.85228 16.5243 3.41852 17.6531 4.241C18.782 5.06348 19.7178 6.12237 20.3952 7.34379C20.8781 8.21444 21.2214 9.15273 21.415 10.1244C21.5445 10.7744 22.1113 11.2744 22.7723 11.227Z"
            fill="#007FA4"
            id="Ellipse 113"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      className={classNames(className, 'vb-loading')}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <g id="Size=sm">
        <path
          d="M15.2 8C15.6418 8 16.0041 8.35907 15.96 8.79869C15.8401 9.99374 15.4522 11.1501 14.8211 12.18C14.0502 13.438 12.9465 14.4582 11.6319 15.1281C10.3174 15.7979 8.84316 16.0911 7.37233 15.9753C5.9015 15.8596 4.49132 15.3393 3.29772 14.4721C2.10411 13.6049 1.17357 12.4245 0.608964 11.0615C0.0443609 9.6984 -0.132307 8.20574 0.0984932 6.74853C0.329293 5.29131 0.95857 3.9263 1.91675 2.80442C2.70121 1.88593 3.68111 1.15969 4.78062 0.676364C5.18509 0.498564 5.63854 0.73219 5.77508 1.15239C5.91161 1.5726 5.67874 2.01945 5.27884 2.2073C4.4583 2.59276 3.72612 3.14955 3.1334 3.84353C2.36686 4.74104 1.86343 5.83305 1.67879 6.99882C1.49415 8.16459 1.63549 9.35872 2.08717 10.4492C2.53885 11.5396 3.28329 12.4839 4.23817 13.1777C5.19306 13.8715 6.3212 14.2877 7.49786 14.3803C8.67453 14.4729 9.85388 14.2383 10.9055 13.7024C11.9572 13.1666 12.8402 12.3504 13.4569 11.344C13.9338 10.5658 14.237 9.69743 14.3501 8.79793C14.4052 8.35955 14.7582 8 15.2 8Z"
          fill="#F0F1F4"
          id="Ellipse 112"
        />
        <path
          d="M15.1445 7.10802C15.583 7.05329 15.898 6.65211 15.7998 6.22134C15.6191 5.42888 15.3183 4.66702 14.9065 3.96263C14.3599 3.02753 13.629 2.21317 12.7583 1.56892C11.8876 0.924678 10.8951 0.463962 9.84097 0.214704C9.04695 0.0269437 8.23043 -0.037883 7.41976 0.0210692C6.9791 0.0531145 6.6876 0.47171 6.76348 0.906973C6.83936 1.34224 7.25419 1.62827 7.69552 1.60725C8.29141 1.57887 8.88967 1.63388 9.47278 1.77176C10.316 1.97117 11.11 2.33974 11.8066 2.85514C12.5032 3.37054 13.0879 4.02202 13.5252 4.7701C13.8276 5.28738 14.0552 5.8434 14.2023 6.42154C14.3113 6.84972 14.7061 7.16276 15.1445 7.10802Z"
          fill="#007FA4"
          id="Ellipse 113"
        />
      </g>
    </svg>
  );
};
